export const AVA_AUTH_TOKEN = 'ava/authenticateWithToken';
export const AVA_AUTH_PASSWORD = 'ava/authticateWithPassword';
